"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpendBundle = void 0;
// https://github.com/Chia-Network/chia-blockchain/blob/6205d954e8ac2ea40ee7386b1ee3124da21f4c4a/chia/types/spend_bundle.py#L20
const fields_1 = __importDefault(require("./fields"));
const coin_spend_1 = require("./coin_spend");
class SpendBundle {
}
__decorate([
    fields_1.default.List(fields_1.default.Object(coin_spend_1.CoinSpend))
], SpendBundle.prototype, "coinSpends", void 0);
__decorate([
    fields_1.default.Bytes(96)
], SpendBundle.prototype, "aggregatedSignature", void 0);
exports.SpendBundle = SpendBundle;
//# sourceMappingURL=spend_bundle.js.map